import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/news/categories', { params })
  },
  store (formData) {
    return apiClient.post('/news/categories', formData)
  },
  show (id, params) {
    return apiClient.get(`/news/categories/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/news/categories/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/news/categories/${id}`)
  }
}
